import { render, staticRenderFns } from "./Fromticket.vue?vue&type=template&id=0960661d"
import script from "./Fromticket.vue?vue&type=script&lang=js"
export * from "./Fromticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports